const Image = ({ src, className="absolute inset-0 w-full h-full object-cover", alt = ""}) => {
    return (
    //<div className="relative pb-[140%]"> {/* Aspect ratio container for images */}
        <img 
            src={src} 
            alt={alt}
            className={className}
      //      className="absolute inset-0 w-full h-full object-cover"
            onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjE0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwIiBoZWlnaHQ9IjE0MCIgZmlsbD0iI2NjYyIvPjx0ZXh0IHg9IjUwIiB5PSI3MCIgZm9udC1zaXplPSIxMiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0iIzk5OSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXdlaWdodD0iYm9sZCI+Tm8gSW1hZ2U8L3RleHQ+PC9zdmc+';
            }}
        />
    //</div>
    )
}

export default Image